import { RichText } from 'prismic-reactjs';
import CardsList from '@components/CardsList';
import { ICollectionCards } from './types';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapCollectionCards } from './mapCollectionCards';

const CollectionCards = ({
  carousel,
  collections,
  title,
}: ICollectionCards) => {
  return (
    <CardsList
      grid={!carousel}
      richTitle={<RichText render={title} />}
      cardList={collections.map((collection) => ({
        url: `/collections/${collection.handle}`,
        title: collection.customTitle || collection.title,
        image: collection.img.url,
        alt: collection.img.alt,
        id: collection.id,
        bgColor: collection.bgColor,
      }))}
    />
  );
};

export default withSlice(CollectionCards, mapCollectionCards);
